import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/download-completed'
import useLocalStorage from 'hooks/useLocalStorage'

const DownloadCompleted: React.FC = () => {
  const fromCorrectFormPage = useLocalStorage('refDownloadModernizationPage')

  return (
    <>
      {fromCorrectFormPage && (
        <CustomHead
          keyword={
            'モダナイゼーション レガシーシステム刷新 クラウドネイティブ AI駆動開発 DX推進 システム移行 IT投資 デジタルシフト'
          }
          image={'https://www.i3design.jp/ogp_logo.png'}
          url={'https://www.i3design.jp/download/modernization/done/'}
          title="ご入力いただきありがとうございます | 失敗しないAI時代のモダナイゼーション戦略 | 資料ダウンロード | i3DESIGN アイスリーデザイン"
          description="ご入力いただいたメールアドレス宛に資料ダウンロード用URLを送付いたしました。メールをご確認いただき、資料をダウンロードしてください。"
          noindexNofollow={true}
        />
      )}
      <Template />
    </>
  )
}

export default DownloadCompleted
